import React from "react";
import {
	HeaderRow,
	PatientContainer,
	AvatarWrapper,
	Photo,
	PatientInfo,
	PatientName,
	PatientDate,
	ChevronRight,
} from "./styles";
import { AICopilotPatient } from "../../useAICopilotViewModel";
import { ReactComponent as FallbackIcon } from "../../../../../../assets/kinologyIcons/svg/patient.svg";
import { ReactComponent as ChevronIcon } from "../../../../../../assets/kinologyIcons/svg/arrow-right-radius.svg";

interface CopilotHeaderProps {
	patient: AICopilotPatient;
	isV1Mode: boolean;
	onClick?: () => void;
}

const CopilotHeader: React.FC<CopilotHeaderProps> = ({
	patient,
	isV1Mode,
	onClick,
}) => {
	return (
		<HeaderRow>
			<PatientContainer
				isV1Mode={isV1Mode}
				onClick={onClick}
				role={onClick ? "button" : undefined}
				tabIndex={onClick ? 0 : undefined}
				onKeyDown={(event) => {
					if (onClick && (event.key === "Enter" || event.key === " ")) {
						event.preventDefault();
						onClick();
					}
				}}
				aria-label={onClick ? "Escolher outro paciente" : undefined}
			>
				<AvatarWrapper hasPhoto={!!patient.photoUrl}>
					{patient.photoUrl ? (
						<Photo src={patient.photoUrl} alt={patient.name} />
					) : (
						<FallbackIcon width="24px" height="24px" fill="#ffffff" />
					)}
				</AvatarWrapper>

				<PatientInfo>
					<PatientName>{patient.name}</PatientName>
					<PatientDate>
						Paciente avaliado em {patient.evaluationDate}
					</PatientDate>
				</PatientInfo>

				{!isV1Mode && (
					<ChevronRight>
						<ChevronIcon
							width="16px"
							height="16px"
							stroke="#ffffff"
							fill="none"
						/>
					</ChevronRight>
				)}
			</PatientContainer>
		</HeaderRow>
	);
};

export default CopilotHeader;
